import { type FC, useCallback, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0AvatarList, PersonAvatarVariant } from '@factorialco/f0-react'

import { ManageMembersModal } from 'modules/posts/components/Groups/CommunityHeader/ManageMembersModal'

type View = 'members' | 'invite' | 'automatic-invites'

type Props = {
  groupId: string
  groupTitle: string
  initialAvatars: PersonAvatarVariant[]
  totalMembersCount?: number
  isOpen?: boolean
  onOpenChange?: (isOpen: boolean) => void
  showTrigger?: boolean
  canManageMembers?: boolean
  isDynamicCommunitiesEnabled?: boolean
  dynamicTeamId?: string | null
  initialView?: View
}

export const MembersList: FC<Props> = ({
  groupId,
  groupTitle,
  initialAvatars,
  totalMembersCount,
  isOpen: controlledIsOpen,
  onOpenChange,
  showTrigger = true,
  canManageMembers = false,
  isDynamicCommunitiesEnabled = false,
  dynamicTeamId = null,
  initialView = 'members',
}) => {
  const initialTotalCount = totalMembersCount ?? initialAvatars.length
  const [internalIsOpen, setInternalIsOpen] = useState(false)

  const isOpen = controlledIsOpen ?? internalIsOpen

  const handleOpenChange = useCallback(
    (value: boolean) => {
      if (controlledIsOpen === undefined) {
        setInternalIsOpen(value)
      }
      onOpenChange?.(value)
    },
    [controlledIsOpen, onOpenChange]
  )

  const MAX_VISIBLE_AVATARS = 3
  const visibleAvatars = initialAvatars.slice(0, MAX_VISIBLE_AVATARS)
  const remainingCount =
    initialTotalCount > MAX_VISIBLE_AVATARS ? initialTotalCount - MAX_VISIBLE_AVATARS : 0

  return (
    <>
      {showTrigger && (
        <Box cursor="pointer" onClick={() => handleOpenChange(true)} width="fit-content">
          <F0AvatarList
            avatars={visibleAvatars}
            remainingCount={remainingCount}
            size="sm"
            type="person"
          />
        </Box>
      )}
      <ManageMembersModal
        groupId={groupId}
        groupTitle={groupTitle}
        isOpen={isOpen}
        onOpenChange={handleOpenChange}
        canManageMembers={canManageMembers}
        isDynamicCommunitiesEnabled={isDynamicCommunitiesEnabled}
        dynamicTeamId={dynamicTeamId}
        initialView={initialView}
      />
    </>
  )
}
